module.exports = __webpack_public_path__ + "static/media/20.1.68da84b4.png";